module.exports = __webpack_public_path__ + "img/dingtalk.411750fc.svg";